import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a75696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Code Review Assistant", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Paste the URL of your GitHub pull request to receive feedback.", -1))
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = {
  key: 0,
  class: "validation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "loading"
}
const _hoisted_8 = {
  key: 1,
  class: "feedback"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prUrl) = $event)),
        placeholder: "Enter pull request URL",
        class: "input-field",
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValidation && _ctx.updateValidation(...args))),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnterKeyPress && _ctx.onEnterKeyPress(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.prUrl]
      ]),
      (_ctx.validation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.validation), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args))),
        class: "submit-btn",
        disabled: !_ctx.isValidUrl(_ctx.prUrl)
      }, "Review pull request", 8, _hoisted_6)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Loading..."))
      : _createCommentVNode("", true),
    (_ctx.llm_output)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", { innerHTML: _ctx.llm_output }, null, 8, _hoisted_9)
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}